import { render, staticRenderFns } from "./AboutYourself.vue?vue&type=template&id=06b24ee0"
import script from "./AboutYourself.vue?vue&type=script&lang=js"
export * from "./AboutYourself.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports